import React from 'react';
import Header from './Header';
import Footer from './Footer';
import VerticalSensorCard from './VerticalSensorCard';
import '../styles/PositionSensors.css';

import i1 from '../assets/InductiveSensor1.png';
import i2 from '../assets/photoelectric-main.png';
import i3 from '../assets/CapacitiveSensorMain.png';
import i4 from '../assets/MagnaticSensorMain1.png';
import i5 from '../assets/ultrasonic_main.png';
import i6 from '../assets/colorSensor.png';

const sensors = [
  {
    image: i1,
    title: 'Inductive Sensors',
    points: ['Wide operating temperature range', 'High protection rating for harsh industrial environments', 'Reliable detection due to low sensor tolerances','Reduced storage due to a wide range of applications'],
    link: '/products/InductiveSensor'
  },
  {
    image: i2,
    title: 'Photoelectric Sensors',
    points: ['Available in a variety of models, like thin type, square type, cylindrical type, transparent object detection type, background suppression type, etc.', 'L.on and D.on switch freely.', 'Solid and durable metal housing; Economical plastic housing and easy to install.','Short circuit protection and reverse polarity protection.','Switch frequency up to 5000Hz.'],
    link: '/products/PhotoelectricSensors'
  },
  {
    image: i3,
    title: 'Capacitive Sensors',
    points: ['High noise immunity', 'Sensing range adjustable by means of potentiometer or teach button', 'Plastic or metal housings for different applications','Sensors for position and level detection','Accessories for mounting on tanks or sight glasses'],
    link: '/products/CapacitiveSensor'
  },
  {
    image: i4,
    title: 'Magnetic Sensors',
    points: ['Non-contact,reliable and solid,abundant types', 'Micron response speed,high measurement sensitivity', 'High positioning accuracy and reliable performance'],
    link: '/products/MagneticSensor'
  },
  {
    image: i5,
    title: 'Ultrasonic Sensors',
    points: ['An all-rounder with a wide range of objects', 'Measuring distance up to 6m, millimeter accuracy', 'It can adapt to a variety of harsh environments, such as high temperature, dust, water mist.'],
    link: '/products/UltrasonicSensor'
  },
  {
    image: i6,
    title: 'Color Mark Detection',
    points: ['Detection Method: Diffuse Reflection', 'Detection Distance: 10mm±3mm', 'Response Time: Color mark mode: 0.5ms; color mode: 2ms','Digital Screen: 4-digit digital tube display','Ambient Temperature: -10°C~+55°C (working), -20°C~+70°C (storage)'],
    link: '/products/ColorMarkDetection'
  }
];

const PositionSensors = () => {
  return (
    <div className="position-sensors-page">
      <Header />
      <section className="position-sensors-hero">
        <h1>Position Sensors</h1>
        <p>Explore our wide range of position sensors for every industrial need.</p>
      </section>

      <section className="sensor-card-grid">
        {sensors.map((sensor, index) => (
          <a href={sensor.link} className="sensor-card-link" key={index}>
            <VerticalSensorCard
              image={sensor.image}
              title={sensor.title}
              points={sensor.points}
            />
          </a>
        ))}
      </section>
      <Footer />
    </div>
  );
};

export default PositionSensors;
